import { getSelectedNode } from 'owa-mail-folder-forest-store';
import type { FolderForestTreeType } from 'owa-graph-schema';
import { GroupFolderForestNode } from 'owa-favorites-types';

export default function isGroupFolderNodeSelected(
    groupId: string,
    folderId: string,
    treeType: FolderForestTreeType
): boolean {
    const selectedNode = getSelectedNode() as GroupFolderForestNode;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        selectedNode?.id &&
        selectedNode?.groupId &&
        selectedNode.treeType == treeType &&
        groupId.toLowerCase() == selectedNode.groupId.toLowerCase() &&
        folderId.toLowerCase() == selectedNode.id.toLowerCase()
    );
}
